import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import { type FC } from "react";
import toast from "react-hot-toast";
import { EMPTY_ARRAY } from "src/utils/empty-values";
import type { StoreAccountAssignment } from "../vc-account-assignments-types";
import { AssignmentsTable } from "./AssignmentsTable";
import { renderToString } from "react-dom/server";

export interface AssignmentSuccessScreenProps {
  confirmedAssignments: StoreAccountAssignment[];
  onDismiss: () => void;
}

export const AssignmentSuccessScreen = ({ confirmedAssignments, onDismiss }: AssignmentSuccessScreenProps) => (
  <>
    <DialogTitle>Your VC account assignments have been successfully confirmed</DialogTitle>
    <div style={{ paddingInline: "1.5rem", paddingTop: 0, paddingBottom: "1rem" }}>
      <div style={{ height: "400px", width: "100%", marginBottom: "1.5rem" }}>
        <AssignmentsTable assignments={confirmedAssignments} />
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "1rem" }}>
        <Button variant="outlined" onClick={onDismiss}>
          Close without saving to clipboard
        </Button>
        <Button variant="outlined" onClick={() => copyAssignmentsTableToClipboard(confirmedAssignments)}>
          Save to clipboard
        </Button>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={() => {
            copyAssignmentsTableToClipboard(confirmedAssignments);
            onDismiss();
          }}
        >
          Save table to clipboard and close
        </Button>
      </div>
    </div>
  </>
);

async function copyAssignmentsTableToClipboard(assignments: StoreAccountAssignment[]) {
  const html = renderToString(<AssignmentClipboardTable assignments={assignments} />);
  navigator.clipboard.write([new ClipboardItem({ "text/html": html })]);
  toast.success("Table copied to clipboard");
}

const AssignmentClipboardTable: FC<{ assignments: StoreAccountAssignment[] }> = ({ assignments }) => (
  <table>
    <thead>
      <tr>
        <th>Store Name</th>
        <th>Account 1 Name</th>
        <th>Account 1 Email</th>
        <th>Account 2 Name</th>
        <th>Account 2 Email</th>
      </tr>
    </thead>
    <tbody>
      {(assignments ?? EMPTY_ARRAY).map(({ storeName, accounts: [account1, account2] }) => (
        <tr key={storeName}>
          <td>{storeName}</td>
          <td>{account1.accountName}</td>
          <td>{account1.email}</td>
          <td>{account2.accountName}</td>
          <td>{account2.email}</td>
        </tr>
      ))}
    </tbody>
  </table>
);
